/*
 * @Author: jingyu.yang 
 * @Date: 2021-12-17 09:50:04 
 * @Last Modified by: jingyu.yang
 * @Last Modified time: 2021-12-17 09:50:29
 */
import { post, getJson } from "./index";
/**
 * @function addWb
 * @desc 新增白板
 * @param {string} roomId 房间id
 * @returns {Promise}
 */
export const addWb = (roomId) => post(config.cvds + 'datashare/wb/add', {
  appId: 'cloud_webcast',
  roomId,
})

/**
 * @function getWbInfo
 * @desc 获取白板信息
 * @param {string} roomId 房间id
 * @returns {Promise}
 */
export const getWbInfo = (roomId) => getJson(config.cvds + 'datashare/wb/wb/info?roomId=' + roomId, {})

/**
 * @function addPage
 * @desc 新增白板页
 * @param {string} roomId 房间id
 * @returns {Promise}
 */
export const addPage = (roomId) => post(config.cvds + 'datashare/wb/page/add', {
  appId: 'cloud_webcast',
  title: "",
  roomId,
})

/**
 * @function wbCall
 * @desc 删除白板页
 * @param {string} data.page 页码
 * @param {string} data.roomId 房间id
 * @returns {Promise}
 */
export const delPage = (data) => post(config.cvds + `datashare/wb/page/delete`, data)

/**
 * @function wbShareInfo
 * @desc 白板共享信息
 * @param {string} roomId 房间id
 * @param {number} annotation 0 不带标注 1 带标注
 * @returns {Promise}
 */
 export const wbShareInfo = (roomId, annotation = 1) => roomId(config.cvds + `datashare/wb/share/info?roomId=${roomId}&annotation=${annotation}`, {})

 /**
  * @function wbCall
  * @desc 白板共享操作
  * @param {string} data.roomId 房间id
  * @returns {Promise}
  */
 export const wbCall = (data) => post(config.cvds + `datashare/wb/share/call`, data)